import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import Button from 'components/CustomButtons/Button.js';
import {
  Collapse,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  TextField,
  InputAdornment,
} from '@material-ui/core';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react';
import CardIcon from 'components/Card/CardIcon';
import {
  MonetizationOn,
  Payment,
  Public,
  ShoppingCart,
  ShowChart,
  Save,
  ArrowDropDown,
  Search
} from '@material-ui/icons';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ModalFilterArticle from 'components/Tvendo/Common/ModalFilterArticle';
import { WithApp } from 'contexts/appContext';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsFindBy, wsGet, wsGetAll, wsCreate } from 'services/WService';
import { Fragment } from 'react';

const useStyles = makeStyles((theme) => ({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: '400',
    display: 'flex',
    alignItems: 'flex-end',
    cursor: 'pointer',
  },
  paper: {
    padding: theme.spacing(1),
    marginBottom: '15px',
    width: '100%',
  },
  marginRight: {
    float: 'right',
    marginBottom: '10px',
  },
  personType: {
    marginBottom: '20px',
    width: '100%',
  },
}));

export default WithApp(function NewProduct(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const { productDetail, setDataProduct } = props;
  const form = useRef(null);
  const [clear, setClear] = useState(false);

  const [processing, setProcessing] = useState(false);
  const [checkSumary, setCheckSummary] = useState(true);
  const [checkBuy, setCheckBuy] = useState(true);
  const [checkSale, setCheckSale] = useState(true);
  const [checkPay, setCheckPay] = useState(false);
  const [checkShow, setCheckShow] = useState(false);
  const [openModalProduct, setOpenModalProduct] = useState(false);
  const [ProductSelect, setProductSelect] = useState(undefined);

  const summary = () => {
    setCheckSummary((prev) => !prev);
  };
  const buy = () => {
    setCheckBuy((prev) => !prev);
  };
  const sale = () => {
    setCheckSale((prev) => !prev);
  };
  const pay = () => {
    setCheckPay((prev) => !prev);
  };
  const show = () => {
    setCheckShow((prev) => !prev);
  };

  //#region getList de Agrupamientos
  const [listCategory, setListCategory] = useState([]);
  const [listLine, setListLine] = useState([]);
  const [listFamily, setListFamily] = useState([]);
  const [listSubFamily, setSubFamily] = useState([]);
  const [listMark, setListMark] = useState([]);

  const [bPartnerId, setBPartnerId] = useState(0);
  const [bPartnerSelect, setBPartnerSelect] = useState({});
  const [catId, setCatId] = useState(0);
  const [lineId, setLineId] = useState(0);
  const [famId, setFamId] = useState(0);

  const [defaultListPrice, setDefaultListPrice] = useState([]);

  async function getListCategory() {
    let response = await wsFindBy('logi/category', 'base_business_partner_id', bPartnerId);
    if (response.success) {
      setListCategory(response.data);
    }
  }
  async function getListLine() {
    let response = await wsFindBy('logi/line', 'logi_category_id', catId);

    if (response.success) {
      setListLine(response.data);
    }
  }
  async function getListFamily() {
    let response = await wsFindBy('logi/family', 'logi_line_id', lineId);
    if (response.success) {
      setListFamily(response.data);
    }
  }
  async function getListSubFamily() {
    let response = await wsFindBy('logi/sub-family', 'logi_family_id', famId);
    if (response.success) {
      setSubFamily(response.data);
    }
  }
  async function ListMark() {
    let response = await wsGetAll('logi/mark');
    if (response.success) {
      setListMark(response.data);
    }
  }

  //#endregion

  //#region getList de Grupos
  const [listItemGroup, setListItemGroup] = useState([]);
  const [listGroupMeasureUnit, setListGroupMeasureUnit] = useState([]);
  const [listPriceList, setPriceList] = useState([]);

  async function ListProductGroup() {
    let response = await wsFindBy('logi/product-group', {
      providers: 'Y',
    });
    if (response.success) {
      setListItemGroup(response.data);
    }
  }

  async function ListMeasureUnit() {
    let response = await wsGetAll('logi/measure-unit');
    if (response.success) {
      setListGroupMeasureUnit(response.data);
    }
  }

  async function ListPrice() {
    let response = await wsGetAll('logi/price-list');
    if (response.success) {
      setPriceList(response.data);
    }
  }
  //#endregion

  //#region Datos de compra
  const [listProvider, setListProvider] = useState([]);
  const [listLengthUnit, setListLengthUnit] = useState([]);

  async function getListProvider() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) {
      setListProvider(response.data);
    }
  }

  async function ListLengthUnit() {
    let response = await wsGetAll('logi/length-unit');
    if (response.success) {
      setListLengthUnit(response.data);
    }
  }
  //#endregion

  //#region  Datos de venta
  const [taxList, setTaxList] = useState([]);

  async function getTaxList() {
    let response = await wsGet('base/tax');
    if (response.success) {
      setTaxList(response.data);
    }
  }
  //#endregion

  //#region Impuestos
  const [canals, setCanals] = useState([]);
  const [listMeasureSUNAT, setListMeasureSUNAT] = useState([]);
  const [listCatalogSUNAT, setListCatalogSUNAT] = useState([]);
  const [listExistenceType, setListExistenceType] = useState([]);
  const [detractions, setDetractions] = useState([]);

  async function ListMeasureSUNAT() {
    let response = await wsGetAll('logi/measure-unit-type');
    if (response.success) {
      setListMeasureSUNAT(response.data);
    }
  }

  async function ListCatalogSUNAT() {
    let response = await wsGetAll('logi/existence-catalog');
    if (response.success) {
      setListCatalogSUNAT(response.data);
    }
  }

  async function ListExistenceType() {
    let response = await wsGetAll('logi/existence-type');
    if (response.success) {
      setListExistenceType(response.data);
    }
  }

  async function ListDetraction() {
    let response = await wsGetAll('base/detraction');
    if (response.success) setDetractions(response.data);
  }

  const listIntaType = [
    { Code: 'N', Name: 'Ninguno' },
    { Code: '01', Name: 'Intangible adquirido' },
    { Code: '02', Name: 'Intagieble en etapa de investigación' },
    { Code: '03', Name: 'En etapa de desarrollo' },
  ];
  //#endregion

  const [product, setProduct] = useState({});

  const handleChange = (e) => {
    let name, value;
    name = e.target.name;
    value = e.target.value;
    setProduct((product) => ({
      ...product,
      [name]: value,
    }));
  };

  const handleProductSelect = (selectedProduct) => {
    setProductSelect(selectedProduct);
    setProduct(prev => ({
      ...prev,
      logi_product_origin_id: selectedProduct.id,
      logi_product_origin_name: `${selectedProduct.ItemName} (${selectedProduct.ItemCode})` // Combina el nombre y el código
    }));
    if (setDataProduct) {
      setDataProduct(prev => ({
        ...prev,
        logi_product_origin_id: selectedProduct.id,
        logi_product_origin_name: `${selectedProduct.ItemName} (${selectedProduct.ItemCode})`
      }));
    }
  };
  
  async function listCanal() {
    let response = await wsGetAll('base/canal');
    if (response.success) {
      setCanals(response.data);
    }
  }

  async function saveProduct(product) {
    setProcessing(true);

    if (product.base_canal_id === 'T') {
      delete product.base_canal_id;
    }

    let response = await wsCreate('logi/product', product);
    if (response.success) {
      showNotify(response.message);
      setProduct({});
      props.reloadProduct();
      setClear(!clear);
    } else {
      showNotify(response.message, 'error');
    }
    setProcessing(false);
  }

  useEffect(() => {
    setProduct(productDetail);
  }, [productDetail]);

  useEffect(() => {
    ListMark();
    ListProductGroup();
    ListMeasureUnit();
    ListPrice();
    listCanal();

    getListProvider();
    ListLengthUnit();
    getTaxList();

    ListMeasureSUNAT();
    ListCatalogSUNAT();
    ListExistenceType();
    ListDetraction();
  }, []);

  useEffect(() => {
    if (bPartnerId != 0) {
      getListCategory();
    }
    if (catId != 0) {
      getListLine();
    }
    if (lineId != 0) {
      getListFamily();
    }
    if (famId != 0) {
      getListSubFamily();
    }
  }, [bPartnerId, catId, lineId, famId]);

  return (
    <Fragment>
      <Toasty action={notify} />
      <GridContainer>
      <ModalFilterArticle
          open={openModalProduct}
          setOpen={setOpenModalProduct}
          entity={`logi/product`}
          setProductSelect={handleProductSelect}
          filterCustom={{
            QryGroup1:'N',
          }}
        />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            saveProduct(product);
          }}
          ref={form}
        >
          {/* Resumen */}
          <GridItem xs={12} lg={12}>
            <Card>
              <CardHeader onClick={summary} icon>
                <CardIcon color={props.themeContext.buttonColorSuccess}>
                  <Public />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Resumen <ArrowDropDown />
                </h4>
              </CardHeader>
              <CardBody>
                <Collapse in={checkSumary} key={1}>
                  <div elevation={4} className={classes.paper}>
                    <GridContainer>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Principal</h5>
                          </GridItem>
                          <GridItem xs={12} sm={6} lg={2}>
                            <TextField
                              name="ItemName"
                              label="Nombre de artículo"
                              value={product.ItemName || ''}
                              required
                              fullWidth
                              margin="normal"
                              onChange={handleChange}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={6} lg={2}>
                            <TextField
                              name="FrgnName"
                              label="Código externo"
                              value={product.FrgnName || ''}
                              required
                              fullWidth
                              margin="normal"
                              onChange={handleChange}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={6} lg={2}>
                            <TextField
                              name="FrgnName2"
                              label="Código externo 2"
                              value={product.FrgnName2 || ''}
                              required
                              fullWidth
                              margin="normal"
                              onChange={handleChange}
                            />
                          </GridItem>

                          <GridItem xs={12} sm={6} lg={2}>
                            <TextField
                              label="Producto de origen"
                              name="logi_product_origin_id"
                              value={product.logi_product_origin_name || ''}
                              onChange={handleChange}
                              margin="normal"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment
                                    style={{ cursor: 'pointer', color: '#07c107' }}
                                    onClick={() => setOpenModalProduct(true)}
                                    position="start"
                                  >
                                    <Search />
                                  </InputAdornment>
                                )
                              }}
                              fullWidth
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={4}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Tipo de artículo</InputLabel>
                              <Select
                                value={product.ItemType || ''}
                                inputProps={{
                                  name: 'ItemType',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="I">Articulo</MenuItem>
                                <MenuItem value="L">Trabajo</MenuItem>
                                <MenuItem value="T">Viaje</MenuItem>
                                <MenuItem value="F">Activo fijo</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} md={4} lg={4}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Bonificación</InputLabel>
                              <Select
                                value={product.QryGroup1 || 'N'}
                                inputProps={{
                                  name: 'QryGroup1',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} md={4} lg={4}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Estado</InputLabel>
                              <Select
                                value={product.state || ''}
                                inputProps={{
                                  name: 'state',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="A">Activo</MenuItem>
                                <MenuItem value="I">Inactivo</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          {/* Canal */}
                          <GridItem xs={12} sm={3} md={3} lg={2}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Canal</InputLabel>
                              <Select
                                value={product.base_canal_id || 'T'}
                                inputProps={{
                                  name: 'base_canal_id',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="T">Todos</MenuItem>
                                {canals.map((canal) => {
                                  return (
                                    <MenuItem key={canal.id} value={canal.id}>
                                      {canal.description}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </GridItem>
                          {/* Combo */}
                          <GridItem xs={12} sm={3} md={3} lg={2}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Combo</InputLabel>
                              <Select
                                value={product.TreeType || 'N'}
                                inputProps={{
                                  name: 'TreeType',
                                  onChange: (e) => {
                                    if (['A', 'S'].includes(e.target.value)) {
                                      setProduct((product) => ({
                                        ...product,
                                        combo_type: 'A',
                                      }));
                                    }
                                    handleChange(e);
                                  },
                                }}
                              >
                                <MenuItem value="N">No</MenuItem>
                                <MenuItem value="A">Ensamblado</MenuItem>
                                <MenuItem value="S">Ventas</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          {/* Tipo combo */}
                          {['A', 'S'].includes(product.TreeType) && (
                            <GridItem xs={12} sm={3} md={3} lg={2}>
                              <FormControl fullWidth margin="normal">
                                <InputLabel>Tipo Combo</InputLabel>
                                <Select
                                  value={product.combo_type || 'A'}
                                  inputProps={{
                                    name: 'combo_type',
                                    onChange: handleChange,
                                  }}
                                >
                                  <MenuItem value="A">Amarre</MenuItem>
                                  <MenuItem value="D">Descuento</MenuItem>
                                </Select>
                              </FormControl>
                            </GridItem>
                          )}
                        </GridContainer>
                      </Paper>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Agrupamiento</h5>
                          </GridItem>
                          {/* <GridItem xs={12} sm={4} lg={4}>
                            <TextField
                              name="U_SYP_MODELO"
                              label="Modelo"
                              value={product.U_SYP_MODELO || ''}
                              fullWidth
                              onChange={handleChange}
                              margin="normal"
                            />
                          </GridItem> */}
                          <GridItem xs={12} sm={4} lg={4}>
                            <Autocomplete
                              key={clear}
                              options={listProvider}
                              getOptionLabel={(option) => option.CardName}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Socio de Negocio"
                                  margin="normal"
                                  required
                                />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    base_business_partner_id: item.id,
                                  });
                                  return setBPartnerId(item.id), setBPartnerSelect(item);
                                } else {
                                  setProduct({
                                    ...product,
                                    base_business_partner_id: null,
                                  });
                                  setBPartnerId(0);
                                  setBPartnerSelect({});
                                }
                              }}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={4}>
                            <Autocomplete
                              key={bPartnerId + clear}
                              options={listCategory}
                              getOptionLabel={(option) => option.description}
                              renderInput={(params) => (
                                <TextField {...params} label="Categoría" margin="normal" required />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    logi_category_id: item.id,
                                  });
                                  return setCatId(item.id);
                                } else {
                                  setProduct({
                                    ...product,
                                    logi_category_id: null,
                                  });
                                  setCatId(0);
                                }
                              }}
                              disabled={bPartnerId == 0}
                            />
                          </GridItem>

                          <GridItem xs={12} sm={3} lg={3}>
                            <Autocomplete
                              key={bPartnerId + catId + clear}
                              options={listLine}
                              getOptionLabel={(option) => option.description}
                              renderInput={(params) => (
                                <TextField {...params} label="Línea" margin="normal" required />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    logi_line_id: item.id,
                                  });
                                  return setLineId(item.id);
                                } else {
                                  setProduct({
                                    ...product,
                                    logi_line_id: null,
                                  });
                                  setLineId(0);
                                }
                              }}
                              disabled={catId == 0}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={3} lg={3}>
                            <Autocomplete
                              key={bPartnerId + catId + lineId + clear}
                              options={listFamily}
                              getOptionLabel={(option) => option.description}
                              renderInput={(params) => (
                                <TextField {...params} label="Familia" margin="normal" required />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    logi_family_id: item.id,
                                  });
                                  return setFamId(item.id);
                                } else {
                                  setProduct({
                                    ...product,
                                    logi_family_id: null,
                                  });
                                  setFamId(0);
                                }
                              }}
                              disabled={lineId == 0}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={3} lg={3}>
                            <Autocomplete
                              key={bPartnerId + catId + lineId + famId + clear}
                              options={listSubFamily}
                              getOptionLabel={(option) => option.description}
                              renderInput={(params) => (
                                <TextField {...params} label="Sub-Familia" margin="normal" />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    logi_sub_family_id: item.id,
                                  });
                                }
                                setProduct({
                                  ...product,
                                  logi_sub_family_id: null,
                                });
                              }}
                              disabled={famId == 0}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={3} lg={3}>
                            <Autocomplete
                              key={clear}
                              options={listMark}
                              getOptionLabel={(option) => option.description}
                              renderInput={(params) => (
                                <TextField {...params} label="Marca" margin="normal" required />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    logi_mark_id: item.id,
                                  });
                                } else {
                                  setProduct({
                                    ...product,
                                    logi_mark_id: null,
                                  });
                                }
                              }}
                            />
                          </GridItem>
                        </GridContainer>
                      </Paper>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Grupos</h5>
                          </GridItem>
                          {/* Grupo de producto */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <Autocomplete
                              key={clear}
                              options={listItemGroup}
                              getOptionLabel={(option) => option.ItmsGrpNam}
                              renderInput={(params) => (
                                <TextField {...params} label="Artículos" margin="normal" required />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    logi_product_group_id: item.id,
                                  });
                                } else {
                                  setProduct({
                                    ...product,
                                    logi_product_group_id: null,
                                  });
                                }
                              }}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Unid. de medida</InputLabel>
                              <Select
                                value={product.logi_measure_unit_id_UgpEntry || ''}
                                inputProps={{
                                  name: 'logi_measure_unit_id_UgpEntry',
                                  onChange: handleChange,
                                }}
                              >
                                {listGroupMeasureUnit.map((item, i) => (
                                  <MenuItem value={item.id} key={i}>
                                    {item.UgpName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                          {/* <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              name="CodeBars"
                              label="Código de Barras"
                              value={product.CodeBars || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                            />
                          </GridItem> */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Compra</InputLabel>
                              <Select
                                value={product.PrchseItem || ''}
                                inputProps={{
                                  name: 'PrchseItem',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Venta</InputLabel>
                              <Select
                                value={product.SellItem || ''}
                                inputProps={{
                                  name: 'SellItem',
                                  onChange: handleChange,
                                }}
                                disabled
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          {/* Precios */}
                          {!(
                            ['A', 'S'].includes(product.TreeType) && product.combo_type === 'A'
                          ) && (
                            <>
                              <GridItem xs={12} sm={4} lg={6}>
                                <Autocomplete
                                  key={clear}
                                  multiple
                                  disableCloseOnSelect={true}
                                  size="small"
                                  options={listPriceList}
                                  getOptionLabel={(option) => option.ListName}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Listas de precios"
                                      margin="normal"
                                      required={product?.price_lists ? false : true}
                                    />
                                  )}
                                  onChange={(e, items) => {
                                    if (!!items) {
                                      let arr = items.map((item) => {
                                        return item.id;
                                      });
                                      setDefaultListPrice(items);
                                      setProduct({
                                        ...product,
                                        price_lists: arr,
                                      });
                                    } else {
                                      setProduct({
                                        ...product,
                                        price_lists: null,
                                      });
                                    }
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={4} lg={3}>
                                <Autocomplete
                                  key={defaultListPrice + clear}
                                  options={defaultListPrice}
                                  getOptionLabel={(option) => option.ListName}
                                  disabled={!product?.price_lists ? true : false}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Lista de precio x defecto"
                                      margin="normal"
                                      required
                                    />
                                  )}
                                  onChange={(e, item) => {
                                    if (!!item) {
                                      setProduct({
                                        ...product,
                                        logi_price_list_id: item.id,
                                      });
                                    } else {
                                      setProduct({
                                        ...product,
                                        logi_price_list_id: null,
                                      });
                                    }
                                  }}
                                />
                              </GridItem>
                            </>
                          )}
                        </GridContainer>
                      </Paper>
                    </GridContainer>
                  </div>
                </Collapse>
              </CardBody>
            </Card>
          </GridItem>
          {/* Datos de compra */}
          <GridItem xs={12} lg={12}>
            <Card>
              <CardHeader onClick={buy} icon>
                <CardIcon color={props.themeContext.buttonColorSuccess}>
                  <ShoppingCart />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Datos de compra <ArrowDropDown />
                </h4>
              </CardHeader>
              <CardBody>
                <Collapse in={checkBuy} key={2}>
                  <div elevation={4} className={classes.paper}>
                    <GridContainer>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Proveedor / Artículo compra</h5>
                          </GridItem>
                          <GridItem xs={12} sm={12} lg={3}>
                            <TextField
                              label="Proveedor"
                              value={bPartnerSelect?.CardName || '-'}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                              disabled
                            />
                          </GridItem>
                          {/* BuyUnitMsr */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Unid. medida compra</InputLabel>
                              <Select
                                value={product.logi_measure_unit_id_BuyUnitMsr || ''}
                                inputProps={{
                                  name: 'logi_measure_unit_id_BuyUnitMsr',
                                  onChange: handleChange,
                                }}
                                required
                              >
                                {listGroupMeasureUnit.map((item, i) => (
                                  <MenuItem value={item.id} key={i}>
                                    {item.UgpName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                          {/* NumInBuy */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Artículos x unid. compra"
                              name="NumInBuy"
                              type="number"
                              value={product.NumInBuy || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                              required
                            />
                          </GridItem>
                          {/* PurPackMsr */}
                          {/* <GridItem xs={12} sm={4} lg={2}>
                            <Autocomplete
                              key={clear}
                              options={listGroupMeasureUnit}
                              getOptionLabel={(option) => option.UgpName}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Unid. medida empaque"
                                  margin="normal"
                                />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    logi_measure_unit_id_PurPackMsr: item.id
                                  });
                                } else {
                                  setProduct({
                                    ...product,
                                    logi_measure_unit_id_PurPackMsr: null
                                  });
                                }
                              }}
                            />
                          </GridItem> */}
                          {/* PurPackUn */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Cantidad empaque"
                              name="PurPackUn"
                              type="number"
                              value={product.PurPackUn || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                              required
                            />
                          </GridItem>
                        </GridContainer>
                      </Paper>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Impuesto / Medidas</h5>
                          </GridItem>
                          {/* TaxCodeAP */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <FormControl fullWidth margin="normal" required>
                              <InputLabel>Impuesto Compra</InputLabel>
                              <Select
                                value={product.base_tax_id || ''}
                                inputProps={{
                                  name: 'base_tax_id',
                                  onChange: handleChange,
                                }}
                              >
                                {taxList.map((tax, i) => (
                                  <MenuItem value={tax.id} key={i}>
                                    {tax.Code}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                          {/* BLength1 */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Logintud"
                              name="BLength1"
                              value={product.BLength1 || ''}
                              onChange={handleChange}
                              type="number"
                              margin="normal"
                              fullWidth
                            />
                          </GridItem>
                          {/* BWidth1 */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Ancho"
                              name="BWidth1"
                              value={product.BWidth1 || ''}
                              onChange={handleChange}
                              type="number"
                              margin="normal"
                              fullWidth
                            />
                          </GridItem>
                          {/* BHeight1 */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Altura"
                              name="BHeight1"
                              value={product.BHeight1 || ''}
                              onChange={handleChange}
                              type="number"
                              margin="normal"
                              fullWidth
                            />
                          </GridItem>
                          {/* BVolUnit */}
                          <GridItem xs={12} sm={4} lg={4}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Unid. volumen</InputLabel>
                              <Select
                                value={product.logi_length_unit_id_BVolUnit}
                                inputProps={{
                                  name: 'logi_length_unit_id_BVolUnit',
                                  onChange: handleChange,
                                }}
                              >
                                {listLengthUnit.map((item, i) => (
                                  <MenuItem key={i} value={item.id}>
                                    {item.UnitName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                          {/* BVolume */}
                          <GridItem xs={12} sm={4} lg={4}>
                            <TextField
                              label="Volumen"
                              name="BVolume"
                              value={product.BVolume || ''}
                              onChange={handleChange}
                              type="number"
                              margin="normal"
                              fullWidth
                            />
                          </GridItem>
                          {/* BWeight1 */}
                          <GridItem xs={12} sm={4} lg={4}>
                            <TextField
                              label="Peso"
                              name="BWeight1"
                              value={product.BWeight1 || ''}
                              onChange={handleChange}
                              type="number"
                              margin="normal"
                              fullWidth
                            />
                          </GridItem>
                        </GridContainer>
                      </Paper>
                    </GridContainer>
                  </div>
                </Collapse>
              </CardBody>
            </Card>
          </GridItem>
          {/* Datos de venta */}
          <GridItem xs={12} lg={12}>
            <Card>
              <CardHeader onClick={sale} icon>
                <CardIcon color={props.themeContext.buttonColorSuccess}>
                  <MonetizationOn />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Datos de venta <ArrowDropDown />
                </h4>
              </CardHeader>
              <CardBody>
                <Collapse in={checkSale} key={3}>
                  <div elevation={4} className={classes.paper}>
                    <GridContainer>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Unid. Medida</h5>
                          </GridItem>
                          {/* SalUnitMsr */}
                          <GridItem xs={12} sm={6} lg={3}>
                            <Autocomplete
                              key={clear}
                              options={listGroupMeasureUnit}
                              getOptionLabel={(option) => option.UgpName}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Unid. medida de venta"
                                  margin="normal"
                                  required
                                />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    logi_measure_unit_id_SalUnitMsr: item.id,
                                  });
                                } else {
                                  setProduct({
                                    ...product,
                                    logi_measure_unit_id_SalUnitMsr: null,
                                  });
                                }
                              }}
                            />
                          </GridItem>
                          {/* NumInSale */}
                          <GridItem xs={12} sm={6} lg={3}>
                            <TextField
                              name="NumInSale"
                              label="Artículos por unid. venta"
                              value={product.NumInSale || ''}
                              onChange={handleChange}
                              type="number"
                              fullWidth
                              margin="normal"
                              required
                            />
                          </GridItem>
                          {/* SalPackMsr */}
                          <GridItem xs={12} sm={6} lg={3}>
                            <Autocomplete
                              key={clear}
                              options={listGroupMeasureUnit}
                              getOptionLabel={(option) => option.UgpName}
                              renderInput={(params) => (
                                <TextField {...params} label="U.M de Empaque" margin="normal" />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    logi_measure_unit_id_SalPackMsr: item.id,
                                  });
                                } else {
                                  setProduct({
                                    ...product,
                                    logi_measure_unit_id_SalPackMsr: null,
                                  });
                                }
                              }}
                            />
                          </GridItem>
                          {/* SalPackUn */}
                          <GridItem xs={12} sm={6} lg={3}>
                            <TextField
                              label="Cantidad por empaque"
                              name="SalPackUn"
                              value={product.SalPackUn || ''}
                              onChange={handleChange}
                              type="number"
                              fullWidth
                              margin="normal"
                              required
                            />
                          </GridItem>
                        </GridContainer>
                      </Paper>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Impuesto / Medidas</h5>
                          </GridItem>
                          {/* TaxCodeAR */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <FormControl fullWidth margin="normal" required>
                              <InputLabel>Impuesto Venta</InputLabel>
                              <Select
                                value={product.base_tax_id_AR || ''}
                                inputProps={{
                                  name: 'base_tax_id_AR',
                                  onChange: handleChange,
                                }}
                              >
                                {taxList.map((tax, i) => (
                                  <MenuItem value={tax.id} key={i}>
                                    {tax.Code}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                          {/* SLength1 */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Logintud"
                              name="SLength1"
                              value={product.SLength1 || ''}
                              onChange={handleChange}
                              type="number"
                              margin="normal"
                              fullWidth
                            />
                          </GridItem>
                          {/* SWidth1 */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Ancho"
                              name="SWidth1"
                              value={product.SWidth1 || ''}
                              onChange={handleChange}
                              type="number"
                              margin="normal"
                              fullWidth
                            />
                          </GridItem>
                          {/* SHeight1 */}
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Altura"
                              name="SHeight1"
                              value={product.SHeight1 || ''}
                              onChange={handleChange}
                              type="number"
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                          {/* SVolUnit */}
                          <GridItem xs={12} sm={4} lg={4}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Unid. volumen</InputLabel>
                              <Select
                                value={product.logi_length_unit_id_SVolUnit || ''}
                                inputProps={{
                                  name: 'logi_length_unit_id_SVolUnit',
                                  onChange: handleChange,
                                }}
                              >
                                {listLengthUnit.map((lengthUnit, i) => (
                                  <MenuItem value={lengthUnit.id} key={i}>
                                    {lengthUnit.UnitName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                          {/* SVolume */}
                          <GridItem xs={12} sm={4} lg={4}>
                            <TextField
                              label="Volumen"
                              name="SVolume"
                              value={product.SVolume || ''}
                              onChange={handleChange}
                              type="number"
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                          {/* SWeight1 */}
                          <GridItem xs={12} sm={4} lg={4}>
                            <TextField
                              label="Peso"
                              name="SWeight1"
                              value={product.SWeight1 || ''}
                              onChange={handleChange}
                              type="number"
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                        </GridContainer>
                      </Paper>
                    </GridContainer>
                  </div>
                </Collapse>
              </CardBody>
            </Card>
          </GridItem>
          {/* Impuestos */}
          <GridItem xs={12} lg={12}>
            <Card>
              <CardHeader onClick={pay} icon>
                <CardIcon color={props.themeContext.buttonColorSuccess}>
                  <Payment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Impuestos <ArrowDropDown />
                </h4>
              </CardHeader>
              <CardBody>
                <Collapse in={checkPay} key={4}>
                  <div elevation={4} className={classes.paper}>
                    <GridContainer>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Gestión</h5>
                          </GridItem>
                          <GridItem xs={12} sm={6} lg={6}>
                            <TextField
                              label="Nombre artículo de origen"
                              name="U_SYP_NOM_OR_REV"
                              value={product.U_SYP_NOM_OR_REV || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                          {/* <GridItem xs={12} sm={3} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Artículo - serie</InputLabel>
                              <Select
                                value={product.ManSerNum || ''}
                                inputProps={{
                                  name: 'ManSerNum',
                                  onChange: handleChange
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem> */}
                          {/* <GridItem xs={12} sm={3} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Artículo - lotes</InputLabel>
                              <Select
                                value={product.ManBtchNum || ''}
                                inputProps={{
                                  name: 'ManBtchNum',
                                  onChange: handleChange
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem> */}
                          <GridItem xs={12} sm={6} lg={6}>
                            <FormControl required fullWidth margin="normal">
                              <InputLabel>Artículo de revaluación</InputLabel>
                              <Select
                                value={product.U_SYP_ES_REVAL || ''}
                                inputProps={{
                                  name: 'U_SYP_ES_REVAL',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </Paper>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Impuestos</h5>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <Autocomplete
                              key={clear}
                              options={detractions}
                              getOptionLabel={(option) => option.WTName}
                              renderInput={(params) => (
                                <TextField {...params} label="Detracciones" margin="normal" />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    U_SYP_CODDET: item.WTCode,
                                  });
                                } else {
                                  setProduct({
                                    ...product,
                                    U_SYP_CODDET: null,
                                  });
                                }
                              }}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={2}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Impuesto acreedores</InputLabel>
                              <Select
                                value={product.TaxCodeAR || ''}
                                inputProps={{
                                  name: 'TaxCodeAR',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={2}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Impuesto indirecto</InputLabel>
                              <Select
                                value={product.IndirctTax || ''}
                                inputProps={{
                                  name: 'IndirctTax',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={6} lg={2}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Sujeto a retención impuestos</InputLabel>
                              <Select
                                value={product.WTLiable || ''}
                                inputProps={{
                                  name: 'WTLiable',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={6} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>No va cuenta de aspectos diferidos</InputLabel>
                              <Select
                                value={product.U_SYP_CTAVTAD || ''}
                                inputProps={{
                                  name: 'U_SYP_CTAVTAD',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </Paper>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>SUNAT</h5>
                          </GridItem>
                          <GridItem xs={12} sm={6} lg={3}>
                            <Autocomplete
                              options={listMeasureSUNAT}
                              getOptionLabel={(option) => option.Name}
                              renderInput={(params) => (
                                <TextField {...params} label="Unid. medida SUNAT" margin="normal" />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    U_SYP_TIPUNMED: item.Code,
                                  });
                                } else {
                                  setProduct({
                                    ...product,
                                    U_SYP_TIPUNMED: null,
                                  });
                                }
                              }}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={6} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Catálogo de existencia SUNAT</InputLabel>
                              <Select
                                value={product.logi_existence_catalog_id_sunat}
                                inputProps={{
                                  name: 'logi_existence_catalog_id_sunat',
                                  onChange: handleChange,
                                }}
                              >
                                {listCatalogSUNAT.map((item, i) => (
                                  <MenuItem key={i} value={item.id}>
                                    {item.Name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={2}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Catálogo de existencia</InputLabel>
                              <Select
                                value={product.logi_existence_catalog_id}
                                inputProps={{
                                  name: 'logi_existence_catalog_id',
                                  onChange: handleChange,
                                }}
                              >
                                {listCatalogSUNAT.map((item, i) => (
                                  <MenuItem key={i} value={item.id}>
                                    {item.Name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={2}>
                            <FormControl required fullWidth margin="normal">
                              <InputLabel>Servicio público</InputLabel>
                              <Select
                                value={product.U_SYP_SERVPUBLICO || ''}
                                inputProps={{
                                  name: 'U_SYP_SERVPUBLICO',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={2}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Requiere ICBPER</InputLabel>
                              <Select
                                value={product.U_SYP_ICBPER || ''}
                                inputProps={{
                                  name: 'U_SYP_ICBPER',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </Paper>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Otros</h5>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <Autocomplete
                              key={clear}
                              options={listExistenceType}
                              getOptionLabel={(option) => option.Name}
                              renderInput={(params) => (
                                <TextField {...params} label="Tipo de existencia" margin="normal" />
                              )}
                              onChange={(e, item) => {
                                if (!!item) {
                                  setProduct({
                                    ...product,
                                    U_SYP_TIPEXIST: item.Code,
                                  });
                                } else {
                                  setProduct({
                                    ...product,
                                    U_SYP_TIPEXIST: null,
                                  });
                                }
                              }}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              name="U_SYP_TOPE"
                              label="Tope de percepción"
                              value={product.U_SYP_TOPE || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Tipo intangible</InputLabel>
                              <Select
                                value={product.U_SYP_TIPOINTANGIBLE || ''}
                                inputProps={{
                                  name: 'U_SYP_TIPOINTANGIBLE',
                                  onChange: handleChange,
                                }}
                              >
                                {listIntaType.map((listIntaType, i) => (
                                  <MenuItem key={i} value={listIntaType.Code}>
                                    {listIntaType.Name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Cód. Naciones Unidas"
                              name="U_SYP_UNSPSC"
                              value={product.U_SYP_UNSPSC || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Descripción Naciones Unidas"
                              name="U_SYP_UNSPSCDES"
                              value={product.U_SYP_UNSPSCDES || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Código CUBSO"
                              name="U_SYP_CUBSO"
                              value={product.U_SYP_CUBSO || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Descripción CUBSO"
                              name="U_SYP_CUBSODES"
                              value={product.U_SYP_CUBSODES || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Cod. de padre"
                              name="U_SYP_COMP_PADRE"
                              value={product.U_SYP_COMP_PADRE || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <TextField
                              label="Nombre de padre"
                              name="U_SYP_NOM_PADRE"
                              value={product.U_SYP_NOM_PADRE || ''}
                              onChange={handleChange}
                              fullWidth
                              margin="normal"
                            />
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Afecto a percepción</InputLabel>
                              <Select
                                value={product.U_SYP_APER || ''}
                                inputProps={{
                                  name: 'U_SYP_APER',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Combustible</InputLabel>
                              <Select
                                value={product.U_SYP_COMBUST || ''}
                                inputProps={{
                                  name: 'U_SYP_COMBUST',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={3}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Gas licuado de petróleo</InputLabel>
                              <Select
                                value={product.U_SYP_GLP || ''}
                                inputProps={{
                                  name: 'U_SYP_GLP',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </Paper>
                    </GridContainer>
                  </div>
                </Collapse>
              </CardBody>
            </Card>
          </GridItem>
          {/* Inventario */}
          <GridItem xs={12} lg={12}>
            <Card>
              <CardHeader onClick={show} icon>
                <CardIcon color={props.themeContext.buttonColorSuccess}>
                  <ShowChart />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Inventario <ArrowDropDown />
                </h4>
              </CardHeader>
              <CardBody>
                <Collapse in={checkShow} key={5}>
                  <div elevation={4} className={classes.paper}>
                    <GridContainer>
                      <Paper className={classes.paper}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} lg={12}>
                            <h5>Gestión</h5>
                          </GridItem>
                          <GridItem xs={12} sm={6} lg={4}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Fijar cta de mayor según</InputLabel>
                              <Select
                                value={product.GLMethod || ''}
                                inputProps={{
                                  name: 'GLMethod',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="C">Grupo de artículos</MenuItem>
                                <MenuItem value="W">Almacén</MenuItem>
                                <MenuItem value="L">Nivel artículo</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={6} lg={4}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Método de valorización</InputLabel>
                              <Select
                                value={product.EvalSystem || ''}
                                inputProps={{
                                  name: 'EvalSystem',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="A">Promedio ponderado</MenuItem>
                                <MenuItem value="S">Estándar</MenuItem>
                                <MenuItem value="F">Fijo</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={4}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Unidad de medida</InputLabel>
                              <Select
                                value={product.Invntryuom || ''}
                                // disabled
                                inputProps={{
                                  name: 'Invntryuom',
                                  onChange: handleChange,
                                }}
                              >
                                {listGroupMeasureUnit.map((item, i) => (
                                  <MenuItem key={i} value={item.UgpCode}>
                                    {item.UgpName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={4}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Artículo inventariable</InputLabel>
                              <Select
                                value={product.InvntItem || ''}
                                inputProps={{
                                  name: 'InvntItem',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={4} lg={4}>
                            <FormControl fullWidth margin="normal">
                              <InputLabel>Gestión de stock por almacén</InputLabel>
                              <Select
                                value={product.Bywh || ''}
                                inputProps={{
                                  name: 'Bywh',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} lg={4}>
                            <TextField
                              label="Comentario"
                              name="UserText"
                              margin="normal"
                              multiline
                              fullWidth
                              onChange={handleChange}
                              value={product.UserText || ''}
                            />
                          </GridItem>
                        </GridContainer>
                      </Paper>
                    </GridContainer>
                  </div>
                </Collapse>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} lg={12}>
            <hr style={{ borderTop: '1px solid #75737361', marginTop: '0px' }} />
          </GridItem>
          <GridItem xs={12} lg={12}>
            <Button
              type="submit"
              round
              color={props.themeContext.buttonColorSuccess}
              className={classes.marginRight}
              disabled={processing}
            >
              <Save className={classes.icons} />
              {processing ? 'Guardando' : 'Guardar'}
            </Button>
          </GridItem>
        </form>
      </GridContainer>
    </Fragment>
  );
});
